import { i18n } from '@/modules/localization';
export default (content) => {
  document.title = i18n.global.t(content, 2) + ' - OS 10';
};
